(function () {
  const STORAGE_KEY = "thegoldencascade_wishlist";

  /* ---------------- MEMORY CACHE ---------------- */
  let wishlistCache = null;

  function getWishlist() {
    if (wishlistCache !== null) return wishlistCache;
    try {
      wishlistCache = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      wishlistCache = [];
    }
    return wishlistCache;
  }

  function saveWishlist(data) {
    wishlistCache = data;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  /* ---------------- HEADER ---------------- */
  function updateHeader() {
    const items = getWishlist();
    const counter = document.querySelector(".wishlist-counter");
    const icon = document.querySelector(".header-wishlist-icon");

    if (counter) counter.textContent = items.length;
    if (icon) icon.classList.toggle("active", items.length > 0);
  }

  /* ---------------- BUTTON STATE (NO FULL DOM SCAN) ---------------- */
  function updateButtonState(button) {
    const wishlist = getWishlist();
    const handle = button.dataset.wishlistHandle;
    button.classList.toggle("active", wishlist.includes(handle));
  }

  function updateVisibleButtons(root = document) {
    root.querySelectorAll("[data-wishlist-handle]").forEach(updateButtonState);
  }

  /* ---------------- ADD / REMOVE ---------------- */
  function addItem(handle) {
    const wishlist = getWishlist();
    if (wishlist.includes(handle)) return;

    wishlist.push(handle);
    saveWishlist(wishlist);

    updateHeader();
    updateVisibleButtons();
  }

  function removeItem(handle) {
    let wishlist = getWishlist().filter(item => item !== handle);
    saveWishlist(wishlist);

    const card = document.querySelector(`.product-card[data-handle="${handle}"]`);
    if (card) card.remove();

    updateHeader();
    updateVisibleButtons();
    toggleEmpty();
  }

  function toggleItem(handle) {
    const wishlist = getWishlist();
    if (wishlist.includes(handle)) removeItem(handle);
    else addItem(handle);
  }

  /* ---------------- WISHLIST PAGE (SEQUENTIAL LOAD = FAST) ---------------- */
  async function renderWishlistPage() {
    const container = document.getElementById("wishlist-container");
    const empty = document.getElementById("wishlist-empty-message");
    if (!container) return;

    const wishlist = getWishlist();
    container.innerHTML = "";

    if (!wishlist.length) {
      if (empty) empty.style.display = "block";
      return;
    }

    if (empty) empty.style.display = "none";

    for (const handle of wishlist) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        container.appendChild(createCard(product));
      } catch (e) {
        console.warn("Wishlist product failed:", handle);
      }
    }
  }

  /* ---------------- CARD ---------------- */
  function createCard(product) {
    const card = document.createElement("div");
    card.className = "product-card";
    card.dataset.handle = product.handle;

    card.innerHTML = `
      <a href="/products/${product.handle}" class="product-card-image">
        <img src="${product.images[0]}" alt="${product.title}" loading="lazy">
      </a>
      <div class="product-card-info">
        <a href="/products/${product.handle}" class="product-card-title">${product.title}</a>
        <div class="product-card-price">₹${(product.price / 100).toFixed(2)}</div>
        <button class="remove-from-wishlist" data-handle="${product.handle}">Remove</button>
      </div>
    `;

    card.querySelector(".remove-from-wishlist")
      .addEventListener("click", e => {
        e.preventDefault();
        removeItem(product.handle);
      });

    return card;
  }

  function toggleEmpty() {
    const container = document.getElementById("wishlist-container");
    const empty = document.getElementById("wishlist-empty-message");
    if (!container || !empty) return;
    empty.style.display = container.children.length ? "none" : "block";
  }

  /* ---------------- EVENT DELEGATION ---------------- */
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-wishlist-handle]");
    if (!btn) return;

    e.preventDefault();
    toggleItem(btn.dataset.wishlistHandle);
    updateButtonState(btn);
  });

  /* ---------------- DAWN SECTION COMPATIBILITY ---------------- */
  document.addEventListener("DOMContentLoaded", () => {
    updateHeader();
    updateVisibleButtons();
    renderWishlistPage();
  });

  document.addEventListener("shopify:section:load", e => {
    updateVisibleButtons(e.target);
    updateHeader();
  });

})();